import {Pipe, PipeTransform} from '@angular/core';
import {PrestationType} from "@prestationType/model";
import {PrestationVisualDetails} from "@planning/model";

@Pipe({
  name: 'groupPrestationVisuals'
})
export class GroupPrestationVisualsPipe implements PipeTransform {
  transform(value: PrestationType[]): {
    groupId?: string;
    name: string;
    description: string;
    prestations: PrestationVisualDetails[];
  }[] {
    const list = [];
    for (let prestation of value) {
      let groupExists = list.some(x => x.groupId == prestation.prestationGroup?.prestation_group_id);
      if (groupExists) {
        list.filter(x => x.groupId == prestation.prestationGroup?.prestation_group_id)[0].prestations
          .push(...prestation.visualPrestationTypes.map(i => ({
            visualId: i.visualPrestationType_id,
            name: prestation.name,
            colorText: i.colorText,
            colorBackground: i.colorBackground,
            prestationTypeId: prestation.id,
            startHours: prestation.startHours,
            endHours: prestation.endHours
          })));
      } else if (!prestation.prestationGroup?.prestation_group_id) {
        list.push({
          name: "N/A",
          description: "N/A",
          groupId: undefined,
          prestations: prestation.visualPrestationTypes.map(i => ({
            visualId: i.visualPrestationType_id,
            name: prestation.name,
            colorText: i.colorText,
            colorBackground: i.colorBackground,
            prestationTypeId: prestation.id,
            startHours: prestation.startHours,
            endHours: prestation.endHours
          }))
        });
      } else {
        list.push({
          name: prestation.prestationGroup.name,
          description: prestation.prestationGroup.description,
          groupId: prestation.prestationGroup.prestation_group_id,
          prestations: prestation.visualPrestationTypes.map(i => ({
            visualId: i.visualPrestationType_id,
            name: prestation.name,
            colorText: i.colorText,
            colorBackground: i.colorBackground,
            prestationTypeId: prestation.id,
            startHours: prestation.startHours,
            endHours: prestation.endHours
          }))
        });
      }
    }

    return list;
  }
}
